






























































































import { Vue, Component } from 'vue-property-decorator';

import { fetchListadoEjecutivos } from './fetchListadoEjecutivos';
import { LoadingService } from '@/services/loadingService';
import moment from 'moment';

import { campos } from '@/pantallas/SucursalVirtual/ListadoEjecutivos/CamposListadoEjecutivos';
import { Funcionalidades } from '@/config/funcionalidades';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  RowNode,
} from 'ag-grid-community';

import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';
import { CodigoAccion } from '@/views/base/VariablesPermisos';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import NavegacionModalCrud from '@/reusable/Mantenedor/NavegacionModalCrud.vue';
import CrudStepperHeader from '@/reusable/Mantenedor/CrudStepperHeader.vue';
import CrudStepperItems from '@/reusable/Mantenedor/CrudStepperItems.vue';
import CrudStepperContent from '@/reusable/Mantenedor/CrudStepperContent.vue';

import { actionsEvent } from '@/setup';
import Confirmation from '@/components/Confirmation.vue';
import BuscadorMantenedor from '@/reusable/Grid/BuscadorMantenedor.vue';
import CabeceraModalCreacion from './CabeceraModalCreacion.vue';
import CabeceraModalEdicion from './CabeceraModalEdicion.vue';

import ComponenteForm from './ComponenteForm.vue';

@Component({
  components: {
    MantenedorGridSinCodigo,
    BuscadorMantenedor,
    Confirmation,
    ModalMantenedor,
    CabeceraModalCreacion,
    CabeceraModalEdicion,
    NavegacionModalCrud,
    CrudStepperHeader,
    CrudStepperItems,
    CrudStepperContent,
    ComponenteForm,
  },
})
export default class ListadoEjecutivos extends Vue {
  constructor() {
    super();
    actionsEvent.onEditar(this.handleEditar);
    actionsEvent.onEliminar(this.handleEliminar);
  }

  info: any = [];
  infoEdicion: any = [];
  busqueda = '';

  mostrarModalEliminacion = false;
  idEliminacion = 0;

  loadingService = new LoadingService();
  $snotify: any;

  /// CABECERA MODAL CREAR ///
  objetoAlta: any = {};
  permitirGuardCrear = false;
  abrirModalCrear = false;
  pasoActivoIndexCrear = 1;
  abrirModalEditar = false;
  pasoActivoIndexEditar = 1;
  abrirModalVer = false;
  pasoActivoIndexVer = 1;

  /// CABECERA MODAL EDITAR ///
  objetoEdicion: any = {};
  permitirGuardEditar = false;

  /// MODAL CREACION ///
  readonly pasosCrear: PasosCrud = {
    configuracion: {
      accion: '',
      visible: true,
      step: 1,
      title: 'Crear Ejecutivo',
      icon: 'info',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
      codigoSubAccion: 40,
      codigoAccionPadre: CodigoAccion.Crear,
    },
  };

  /// MODAL EDICION ///
  readonly pasosEditar: PasosCrud = {
    configuracion: {
      accion: '',
      visible: true,
      step: 1,
      title: 'Editar Ejecutivo',
      icon: 'info',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
      codigoSubAccion: 40,
      codigoAccionPadre: CodigoAccion.Editar,
    },
  };

  /// TABLA ///
  gridApi: GridApi = null;
  enrichedGridOptions: GridOptions = null;
  readonly funcionalidad: Funcionalidades = Funcionalidades.ListadoEjecutivos;
  readonly gridOptions: GridOptions = {
    columnDefs: campos,
    onGridReady: this.handleGridReady,
    isExternalFilterPresent: this.isExternalFilterPresent,
    doesExternalFilterPass: this.doesExternalFilterPass,
    domLayout: 'autoHeight',
    paginationPageSize: 50,
    processCellForClipboard: ({ value }) => {
      return value instanceof moment
        ? this.formatFecha(value as moment.Moment)
        : value;
    },
  };
  handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.renderGrilla();
  }
  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }
  handleBusqueda(consulta: string) {
    this.busqueda = consulta.toLowerCase();
    this.gridApi.onFilterChanged();
  }
  doesExternalFilterPass(node: RowNode): boolean {
    if (this.info.length > 0 && this.busqueda.length > 0) {
      let search =
        node.data.activo.toLowerCase().includes(this.busqueda) ||
        node.data.email.toLowerCase().includes(this.busqueda);
      return search;
    }
    return true;
  }
  isExternalFilterPresent(): boolean {
    return true;
  }
  /// FIN TABLA ///

  /// GRILLA ///
  async renderGrilla() {
    await this.cargaGrilla();
    this.gridApi.setRowData(this.info);
    this.gridApi.setDomLayout('autoHeight');
  }

  cargaGrilla() {
    this.loadingService.showLoading(undefined, 'cargaGrilla');
    this.info = [];
    return fetchListadoEjecutivos('getListadoEjecutivos', {})
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.info = data.data.data;
          for (let i of this.info) {
            if (i.activo == 'f') i.activo = '🔴 Inactivo';
            else i.activo = '🟢 Activo';
          }
        } else {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
          this.info = [];
        }
      })
      .catch((err: any) => console.error(err))
      .finally(() => this.loadingService.hideLoading('cargaGrilla'));
  }
  /// FIN GRILLA ///

  /// CREACION ///
  objsParaAlta(obj: any) {
    this.objetoAlta = obj;
    this.objetoAlta['idModulo'] = Funcionalidades.ListadoEjecutivos;
    if (this.objetoAlta.correo && this.objetoAlta.estado)
      this.permitirGuardCrear = true;
  }

  handleCrear() {
    this.loadingService.showLoading(undefined, 'handleCrear');
    return fetchListadoEjecutivos('createEjecutivo', this.objetoAlta)
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1')
          this.$snotify.success(data.data.MENSAJE_RESPUESTA, 3000);
        else this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
      })
      .catch((err: any) => console.error(err))
      .finally(() => {
        this.cerrarModalCrear();
        this.loadingService.hideLoading('handleCrear');
      });
  }

  cerrarModalCrear() {
    this.renderGrilla();
    this.abrirModalCrear = false;
    this.pasoActivoIndexCrear = 1;
    this.permitirGuardCrear = false;
    return true;
  }

  get estadoIdCrear() {
    const { entity } = this.pasosCrear.configuracion.formState;
    if (!entity) return null;
    return entity.estado;
  }
  /// FIN CREACION ///

  /// EDICION ///
  objsParaEdicion(obj: any) {
    this.objetoEdicion = obj;
    this.objetoEdicion['idModulo'] = Funcionalidades.ListadoEjecutivos;
    this.permitirGuardEditar = true;
  }

  guardarEdicion() {
    this.loadingService.showLoading(undefined, 'guardarEdicion');
    return fetchListadoEjecutivos('editEjecutivo', this.objetoEdicion)
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1')
          this.$snotify.success(data.data.MENSAJE_RESPUESTA, 3000);
        else this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
      })
      .catch((err: any) => console.error(err))
      .finally(() => {
        this.cerrarModalEditar();
        this.loadingService.hideLoading('guardarEdicion');
      });
  }

  handleEditar(e: any) {
    this.infoEdicion = [];
    this.infoEdicion.push(e.data);
    this.abrirModalEditar = true;
    return true;
  }

  cerrarModalEditar() {
    this.renderGrilla();
    this.pasoActivoIndexEditar = 1;
    this.abrirModalEditar = false;
    this.permitirGuardEditar = false;
    return true;
  }

  get estadoIdEditar() {
    const { entity } = this.pasosEditar.configuracion.formState;
    if (!entity) return null;
    return entity.estado;
  }
  /// FIN EDICION ///

  /// ELIMINACION ///
  handleEliminar(e: any) {
    this.mostrarModalEliminacion = true;
    this.idEliminacion = e.data.id;
  }

  respuestaModal(respuesta: any) {
    if (respuesta) {
      let objEliminacion = {
        idEjecutivo: this.idEliminacion,
        usuarioID: JSON.parse(localStorage.getItem('user')).id,
        idModulo: Funcionalidades.ListadoEjecutivos,
      };
      this.loadingService.showLoading(undefined, 'respuestaModal');
      return fetchListadoEjecutivos('deleteEjecutivo', objEliminacion)
        .then((data: any) => {
          if (data.data.CODIGO_RESPUESTA == '1')
            this.$snotify.success(data.data.MENSAJE_RESPUESTA, 3000);
          else this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
        })
        .catch((err: any) => console.error(err))
        .finally(() => {
          this.loadingService.hideLoading('respuestaModal');
          this.mostrarModalEliminacion = false;
          this.idEliminacion = 0;
          this.renderGrilla();
        });
    } else {
      this.mostrarModalEliminacion = false;
      this.idEliminacion = 0;
    }
  }
  /// FIN ELIMINACION ///
}
